import { Component } from 'react'
import { connect } from 'react-redux'
import * as ACT from './actions'
import s from './Deals.scss'
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-grid.css' // eslint-disable-line
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-theme-balham.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/ag-grid.css' // eslint-disable-line
import { preventDefault, utcDate, utcCurrentDate } from 'utils/helpers'
import moment from 'moment'
import { AddButton } from 'components/common/AddButton'
import { FaPlusCircle } from 'react-icons/fa'
import { DealsModal } from './DealsModal'
import { RangeDatePicker } from 'components/ideal-core-ui'
import { SwitchView } from 'components/common/SwitchView'
import { toBoardData } from './serializers'
import { toUsersSelect } from 'components/Users/serializers'
import { toDealStatusesMapper } from 'utils/serializers'
import { createSelector } from 'reselect'
import { isAdmin, getUser } from 'utils/authService'
import Select from 'react-select'
import { PageTitle } from 'components/common/PageTitle'
import swal from 'sweetalert'
import { checkDealProposalsFollowUpDates } from 'components/Deal/utils'
import Cookies from 'universal-cookie'
import { FollowupDateModal } from 'components/common/modals/FollowupDateModal'
import { ContractorAwardedModal } from 'components/common/modals/ContractorAwardedModal'
import { LostOpportunityModal } from 'components/common/modals/LostOpportunityModal'
import { COOKIES } from 'utils/constants'
import cloneDeep from 'lodash/cloneDeep'
import { withRouter } from 'hocs'
import { Outlet } from 'react-router-dom'
import { makeGetRequest } from 'utils/api'
import { AdditionalFilters } from './AdditionalFilters'
import debounce from 'debounce-promise'
import isEqual from 'lodash/isEqual'

const cookies = new Cookies()

const setAdditionalFiltersInCookies = (property, filters) => {
  const sessionAdditionalFilters = cookies.get(COOKIES.DEALS_ADDITIONAL_FILTERS)
  cookies.set(
    COOKIES.DEALS_ADDITIONAL_FILTERS,
    {
      ...(sessionAdditionalFilters ? sessionAdditionalFilters : {}),
      [property]: filters
    },
    {
      path: '/',
      expires: moment().add(8, 'weeks').toDate()
    }
  )
}

const shouldUpdateAdditionalFiltersState = (prevState, sessionAdditionalFilters) => {
  return Boolean(
    sessionAdditionalFilters &&
    ((sessionAdditionalFilters.categories &&
      !isEqual(sessionAdditionalFilters.categories, prevState.filters.categories)) ||
      (sessionAdditionalFilters.contractTypes &&
        !isEqual(sessionAdditionalFilters.contractTypes, prevState.filters.contractTypes)) ||
      (sessionAdditionalFilters.awarded &&
        sessionAdditionalFilters.awarded !== prevState.filters.awarded) ||
      (sessionAdditionalFilters.geographicalAreas &&
        !isEqual(
          sessionAdditionalFilters.geographicalAreas,
          prevState.filters.geographicalAreas
        )) ||
      (sessionAdditionalFilters.priorities &&
        !isEqual(sessionAdditionalFilters.priorities, prevState.filters.priorities)) ||
      (sessionAdditionalFilters.scopes &&
        !isEqual(sessionAdditionalFilters.scopes, prevState.filters.scopes)) ||
      (sessionAdditionalFilters.sizes &&
        !isEqual(sessionAdditionalFilters.sizes, prevState.filters.sizes)) ||
      (sessionAdditionalFilters.sources &&
        !isEqual(sessionAdditionalFilters.sources, prevState.filters.sources)) ||
      (sessionAdditionalFilters.workTypes &&
        !isEqual(sessionAdditionalFilters.workTypes, prevState.filters.workTypes)) ||
      (sessionAdditionalFilters.teams &&
        !isEqual(sessionAdditionalFilters.teams, prevState.filters.teams)))
  )
}

const dealsStatusesSelector = state => state.deals.dealsStatuses
const statusesSelector = createSelector([dealsStatusesSelector], dealsStatuses => {
  return toDealStatusesMapper(dealsStatuses)
})
@withRouter
@connect(({ deals, users, companies, settings }) => {
  const { rowData, pagination, dealsHeader: boardHeaders, dealsStatuses } = deals
  const userList = toUsersSelect(users.users, { withTeams: false })
  return {
    rowData,
    boardHeaders,
    users: userList,
    boardData: toBoardData(rowData, dealsStatuses),
    companies,
    pagination,
    dealsStatuses: statusesSelector({ deals: { dealsStatuses } }),
    settings: settings.settings
  }
})
class DealsContainer extends Component {
  state = {
    initialFullRender: true,
    showAddDealModal: false,
    showDealFollowup: false,
    showContractorAwardedModal: false,
    boardView: true,
    listView: false,
    selectedDeal: null,
    draggedDeal: null,
    draggedDealNewStatus: '',
    filteredByUser: {
      value: getUser().id,
      label: getUser().name
    },
    filters: {
      startDate: utcCurrentDate(null, true).subtract(2, 'weeks').startOf('day').format(),
      endDate: utcCurrentDate(null, true).add(6, 'weeks').endOf('day').format(),
      categories: null,
      contractTypes: null,
      awarded: false,
      geographicalAreas: null,
      priorities: null,
      scopes: null,
      sizes: null,
      sources: null,
      workTypes: null,
      teams: null
    },
    selectedLaneId: '',
    isWonByUs: false,
    showLostOpportunityModal: false,
    additionalFilters: null
  }

  boardColumnsRefs = {}
  addBoardColumnRef = (element, id) => {
    if (this.boardColumnsRefs) {
      this.boardColumnsRefs[id] = element
    }
  }

  async componentDidMount() {
    await this.setActiveTab()
    this.getDeals()
    this.props.dispatch({
      type: ACT.USERS_FETCH_REQUESTED
    })
    this.props.dispatch({
      type: ACT.DEAL_STATUSES_FETCH_REQUESTED
    })

    const response = await makeGetRequest('/v1/organization/deals-board-filters')
    this.setState({
      additionalFilters: response
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const sessionDateRangeFilters = cookies.get(COOKIES.DATE_RANGE_FILTERS)
    const sessionUsersFilter = cookies.get(COOKIES.USERS_FILTERS)
    const sessionAdditionalFilters = cookies.get(COOKIES.DEALS_ADDITIONAL_FILTERS)
    const hash = this.props.router.location.pathname.split('/')[2] || 'board'

    const view = {
      boardView: hash === 'board',
      listView: hash === 'list'
    }
    if (this.state.initialFullRender) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        initialFullRender: false
      })
    }
    if (prevState.boardView !== view.boardView || prevState.listView !== view.listView) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        boardView: view.boardView,
        listView: view.listView
      })
    }
    if (
      !this.state.initialFullRender &&
      (prevState.boardView !== this.state.boardView || prevState.listView !== this.state.listView)
    ) {
      this.getDeals()
    }
    if (
      sessionDateRangeFilters &&
      (sessionDateRangeFilters.startDate !== prevState.filters.startDate ||
        sessionDateRangeFilters.endDate !== prevState.filters.endDate)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        filters: {
          ...this.state.filters,
          startDate: sessionDateRangeFilters.startDate,
          endDate: sessionDateRangeFilters.endDate
        }
      })
    }
    if (
      sessionUsersFilter &&
      sessionUsersFilter.filteredByUser.value !== prevState.filteredByUser.value
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        filteredByUser: sessionUsersFilter.filteredByUser
      })
    }
    if (shouldUpdateAdditionalFiltersState(this.state, sessionAdditionalFilters)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          ...sessionAdditionalFilters
        }
      }))
    }
  }

  setActiveTab = () => {
    const hash = this.props.router.location.pathname.split('/')[2]
    this.changeView(hash)
  }

  getDeals = () => {
    const { filteredByUser } = this.state
    if (this.state.boardView) {
      if (filteredByUser.value !== -1) {
        this.filterBoardDealsByUser(filteredByUser.value)
      } else {
        this.props.dispatch({
          type: ACT.DEALS_BOARD_ROW_DATA_FETCH_REQUESTED,
          payload: {
            filters: this.state.filters
          }
        })
      }
    }
  }

  toggleAddDealModal = () => {
    this.setState(prevState => ({
      showAddDealModal: !prevState.showAddDealModal
    }))
  }

  createDeal = (deal, cb) => {
    this.props.dispatch({
      type: ACT.CREATE_DEAL_REQUESTED,
      payload: {
        deal,
        cb
      }
    })
  }

  changeView = view => {
    this.setState({
      boardView: view === 'board',
      listView: view === 'list'
    })
    const { router } = this.props
    let path = router.location.pathname.split('/')
    path.pop()
    this.props.router.navigate(`${path.join('/')}/${view}`)
  }

  getPageTitle = () => {
    const { boardView } = this.state
    const viewName = boardView ? 'Board View' : 'Table View'
    return `Opportunities ${viewName}`
  }

  toggleFollowupDateModal = () => {
    this.setState(prevState => ({
      showDealFollowup: !prevState.showDealFollowup
    }))
  }

  toggleContractorAwardedModal = params => {
    this.setState(prevState => ({
      showContractorAwardedModal: !prevState.showContractorAwardedModal,
      isWonByUs: !!params
    }))
  }

  toggleLostOpportunityModal = () => {
    this.setState(prevState => ({
      showLostOpportunityModal: !prevState.showLostOpportunityModal
    }))
  }

  revertDealStatus = (cb, deal) => {
    const { draggedDeal } = this.state
    this.props.dispatch({
      type: ACT.DEAL_REVERT_STATUS,
      payload: {
        deal: deal || draggedDeal
      }
    })
    this.setState({
      draggedDeal: null,
      draggedDealNewStatus: ''
    })

    cb && cb()
  }

  cancelUpdateFollowUp = () => {
    this.revertDealStatus(this.toggleFollowupDateModal)
  }

  cancelContractorAwarded = () => {
    this.revertDealStatus(this.toggleContractorAwardedModal)
  }

  cancelLostOpportunity = () => {
    this.revertDealStatus(this.toggleLostOpportunityModal)
  }

  changeStatus = (status, deal) => {
    const newStatus = this.props.dealsStatuses[status.code || status]
    const oldStatusCategory =
      deal.status?.category ?? this.props.dealsStatuses[deal.status].category

    this.setState({
      draggedDeal: deal,
      draggedDealNewStatus: status.code || status
    })
    if (newStatus.category.code.toLowerCase() === 'won') {
      if (!deal.proposals.length || oldStatusCategory.code.toLowerCase() === 'won') {
        this.toggleContractorAwardedModal({ isWonByUs: true })
      } else {
        if (
          ['USER_DISABLED', 'SYSTEM_DISABLED'].includes(
            this.props.settings?.dealSettings.statusAutomation
          )
        ) {
          this.updateStatus(status, deal)
          return
        }

        swal(
          'This opportunity has proposals',
          'Please go to the Proposals tab, move proposals in the appropriate status and the opportunity will be automatically updated'
        )
        this.revertDealStatus(null, deal)
      }
    } else if (newStatus.category.code.toLowerCase() === 'lost') {
      if (
        !deal.proposals.length ||
        (oldStatusCategory.code.toLowerCase() === 'lost' &&
          (!['NN', 'YN'].includes(status.code || status) ||
            !['NN', 'YN'].includes(deal.status.code || deal.status)))
      ) {
        this.toggleLostOpportunityModal({
          newDealStatus: newStatus
        })
      } else {
        if (
          ['USER_DISABLED', 'SYSTEM_DISABLED'].includes(
            this.props.settings?.dealSettings.statusAutomation
          )
        ) {
          this.updateStatus(status, deal)
          return
        }

        swal(
          'This opportunity has proposals',
          oldStatusCategory.code.toLowerCase() === 'won'
            ? 'Please go to the proposals tab and mark all of them as lost by us or by clients. The status of the opportunity will be automatically updated'
            : 'Please go to the Proposals tab, move proposals in the appropriate status and the opportunity will be automatically updated'
        )
        this.revertDealStatus(null, deal)
      }
    } else {
      if (['won', 'lost'].includes(oldStatusCategory.code.toLowerCase()) && deal.proposals.length) {
        if (
          ['USER_DISABLED', 'SYSTEM_DISABLED'].includes(
            this.props.settings?.dealSettings.statusAutomation
          )
        ) {
          this.updateStatus(status, deal)
          return
        }

        swal(
          'This opportunity has proposals',
          'Please go to the Proposals tab, move proposals in the appropriate status and the opportunity will be automatically updated'
        )
        this.revertDealStatus(null, deal)
        return
      }
      if (status === 'CONTRACTORAWARDED') {
        this.toggleContractorAwardedModal()
      } else if (newStatus.category.code.toLowerCase() === 'followup') {
        this.toggleFollowupDateModal()
      } else {
        this.updateStatus(status, deal)
      }
    }
  }

  updateStatus = (status, deal, dealFollowupDate = null, proposalsFollowupDate = null) => {
    this.props.dispatch({
      type: ACT.DEAL_UPDATE_STATUS_REQUESTED,
      payload: {
        id: deal.id,
        status,
        oldStatus: deal.status.code || deal.status,
        dealFollowupDate,
        proposalsFollowupDate,
        userId: this.state.filteredByUser.value,
        filters: this.state.filters,
        awardedCompanyId: deal.awardedCompany?.id || deal.awardedCompany?.value
      }
    })
  }

  filterBoardDealsByUser = id => {
    this.props.dispatch({
      type: ACT.DEALS_BOARD_FOR_USER_FETCH_REQUESTED,
      payload: {
        id,
        filters: this.state.filters
      }
    })
  }

  navigateTo = (e, url) => {
    preventDefault(e)
    this.props.router.navigate(url)
  }

  setDateFilters = dates => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          startDate: utcDate(dates.from),
          endDate: utcDate(dates.to)
        }
      },
      () => {
        this.getDeals()
      }
    )
  }

  updateDealStatusFollowupDate = async (followUpDate, e, deal) => {
    this.checkProposalsAndUpdateFollowUp(followUpDate, deal)
  }

  updateDealsStatusFollowupDate = async (followUpDate, deals) => {
    this.checkDealsProposalsAndUpdateFollowUp(followUpDate, deals)
  }

  checkDealsProposalsAndUpdateFollowUp = async (date, deals) => {
    let totalProposals = []
    deals.forEach(deal => {
      const { proposals } = deal
      totalProposals = [...totalProposals, ...proposals]
    })
    if (checkDealProposalsFollowUpDates(date, totalProposals)) {
      const willChangeFollowUp = await swal({
        title: `One or more proposals have a different follow-up date.
          This new date will apply to all proposals from these opportunities.`,
        text: 'Are you sure you want to continue?',
        buttons: ['Cancel', 'Yes'],
        icon: 'warning'
      })
      if (willChangeFollowUp) {
        this.updateDealsFollowupDate(deals, date)
      }
    } else {
      this.updateDealsFollowupDate(deals, date)
    }
  }

  updateDealStatusContractorAwarded = params => {
    const { awardedCompany, bidStatus, followUpDate, reason, isLostModal } = params
    const { draggedDealNewStatus, draggedDeal, filters, filteredByUser } = this.state

    const clonedDeal = cloneDeep(draggedDeal)
    clonedDeal.awardedCompany = awardedCompany
    clonedDeal.bidStatus = bidStatus
    if (followUpDate) clonedDeal.followUpDate = utcDate(followUpDate)
    if (reason) clonedDeal.noWinReason = reason

    this.props.dispatch({
      type: ACT.DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_REQUESTED,
      payload: {
        deal: clonedDeal,
        status: draggedDealNewStatus,
        oldStatus: clonedDeal.status.code || clonedDeal.status,
        userId: filteredByUser.value,
        filters
      }
    })

    if (isLostModal) {
      this.toggleLostOpportunityModal()
    } else {
      this.toggleContractorAwardedModal()
    }
  }

  updateDraggedDealFollowupDate = async (id, date, event, status) => {
    preventDefault(event)
    const deal = this.props.rowData[status.code || status].find(deal => deal.id === id)
    this.checkProposalsAndUpdateFollowUp(date, deal)
  }

  updateDealFollowupDate = (deal, dealFollowupDate = null, proposalsFollowupDate = null) => {
    if (dealFollowupDate) {
      this.props.dispatch({
        type: ACT.DEAL_FOLLOWUP_DATE_UPDATE_REQUESTED,
        payload: {
          id: deal.id,
          followUpDate: dealFollowupDate,
          ...([deal.status.code, deal.status].includes('CONTRACTORAWARDED')
            ? { awardedCompanyId: deal.awardedCompany.id || deal.awardedCompany.value }
            : {})
        }
      })
    }

    if (proposalsFollowupDate) {
      this.props.dispatch({
        type: ACT.DEAL_UPDATE_PROPOSALS_FOLLOWUP_REQUESTED,
        payload: {
          id: deal.id,
          followUpDate: proposalsFollowupDate
        }
      })
    }
  }

  updateDealsFollowupDate = (deals, date) => {
    this.props.dispatch({
      type: ACT.DEALS_FOLLOWUP_DATE_UPDATE_REQUESTED,
      payload: {
        ids: deals.map(deal => ({
          dealId: deal.id,
          companyIds: deal.dealCompanies.map(c => c.id)
        })),
        followUpDate: date,
        status: deals[0].status.code || deals[0].status,
        startDate: this.state.filters.startDate,
        endDate: this.state.filters.endDate
      }
    })
  }

  updateFollowupDate = (deal, date) => {
    if (
      this.state.draggedDealNewStatus &&
      this.state.draggedDealNewStatus !== (deal.status.code || deal.status)
    ) {
      this.updateStatus(this.state.draggedDealNewStatus, deal, date, date)
    } else {
      this.updateDealFollowupDate(deal, date, date)
    }
  }

  checkProposalsAndUpdateFollowUp = async (date, deal) => {
    const { proposals } = deal
    if (checkDealProposalsFollowUpDates(date, proposals)) {
      const willChangeFollowUp = await swal({
        title: `One or more proposals have a different follow-up date.
          This new date will apply to all proposals from this opportunity.`,
        text: 'Are you sure you want to continue?',
        buttons: ['Cancel', 'Yes'],
        icon: 'warning'
      })
      if (willChangeFollowUp) {
        this.updateFollowupDate(deal, date)
      }
    } else {
      this.updateFollowupDate(deal, date)
    }
  }

  setPagination = (laneId, requestedPage) => {
    this.props.dispatch({
      type: ACT.DEAL_BOARD_FETCH_NEXT_PAGE,
      payload: {
        userId: this.state.filteredByUser.value,
        filters: this.state.filters,
        laneId,
        page: requestedPage
      }
    })
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([])
      }, 1000)
    })
  }

  onLaneScroll = debounce(
    (requestedPage, laneId) => {
      const { pagination } = this.props
      let page = pagination[laneId] ? pagination[laneId].page : 1
      if (pagination[laneId] && pagination[laneId].isLast) {
        return new Promise(function (resolve) {
          resolve([])
        })
      }
      if (pagination[laneId]) {
        page = page + 1
      }
      return this.setPagination(laneId, page)
    },
    4000,
    { leading: true }
  )

  toggleSelectDeal = (event, laneId, dealId) => {
    preventDefault(event)
    this.props.dispatch({
      type: ACT.DEAL_BOARD_TOGGLE_SELECT_DEAL,
      payload: {
        laneId,
        dealId,
        selectedLaneId: this.state.selectedLaneId
      }
    })
    if (this.state.selectedLaneId !== laneId) {
      this.setState({
        selectedLaneId: laneId
      })
    }
  }

  toggleSelectAllDeals = (event, laneId, selected, cb) => {
    preventDefault(event)
    cb && cb()

    this.props.dispatch({
      type: ACT.DEAL_BOARD_TOGGLE_SELECT_ALL_DEALS,
      payload: {
        laneId,
        selected,
        selectedLaneId: this.state.selectedLaneId
      }
    })

    if (this.state.selectedLaneId !== laneId) {
      this.setState({
        selectedLaneId: laneId
      })
    }
  }

  expandCard = (laneId, cardId, expanded) => {
    if (!expanded) {
      this.props.dispatch({
        type: ACT.DEALS_BOARD_FETCH_DEAL_TASKS_REQUESTED,
        payload: {
          laneId,
          cardId
        }
      })
    }
    this.props.dispatch({
      type: ACT.DEAL_BOARD_EXPAND_DEAL,
      payload: {
        laneId,
        cardId
      }
    })
  }

  hasAdditionalFilters = () => {
    const { additionalFilters } = this.state
    return (
      additionalFilters &&
      (additionalFilters.hasCategory ||
        additionalFilters.hasContractType ||
        additionalFilters.hasContractorAwarded ||
        additionalFilters.hasGeographicalArea ||
        additionalFilters.hasPriority ||
        additionalFilters.hasScope ||
        additionalFilters.hasSize ||
        additionalFilters.hasSource ||
        additionalFilters.hasWorkType ||
        additionalFilters.hasTeams)
    )
  }

  changeAdditionalFilters = (value, property) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          [property]: value
        }
      },
      () => {
        this.getDeals()
        setAdditionalFiltersInCookies(property, value)
      }
    )
  }

  isFilteredByAdditionalFilters = () => {
    const { filters } = this.state
    return (
      (filters.categories && filters.categories.length) ||
      (filters.contractTypes && filters.contractTypes.length) ||
      filters.awarded ||
      (filters.geographicalAreas && filters.geographicalAreas.length) ||
      (filters.priorities && filters.priorities.length) ||
      (filters.scopes && filters.scopes.length) ||
      (filters.sizes && filters.sizes.length) ||
      (filters.sources && filters.sources.length) ||
      (filters.workTypes && filters.workTypes.length) ||
      (filters.teams && filters.teams.length)
    )
  }

  render() {
    return (
      <>
        <PageTitle view={this.getPageTitle()} />
        <section className={s.section}>
          {this.state.boardView && (
            <AddButton
              cy="add_new_deal_btn"
              className={s.addDealBtn}
              onClick={this.toggleAddDealModal}
            >
              <FaPlusCircle />
              Add Opportunity
            </AddButton>
          )}
          {isAdmin() && (
            <Select
              onChange={value => {
                if (this.state.boardView) {
                  this.filterBoardDealsByUser(value.value)
                }
                this.setState(
                  {
                    filteredByUser: value
                  },
                  () => {
                    cookies.set(
                      COOKIES.USERS_FILTERS,
                      {
                        filteredByUser: value
                      },
                      {
                        path: '/',
                        expires: moment().add(8, 'weeks').toDate()
                      }
                    )
                  }
                )
              }}
              options={[
                {
                  value: -1,
                  label: 'All Users'
                },
                ...this.props.users
              ]}
              value={this.state.filteredByUser}
              className={s.userSelect}
            />
          )}
          {this.state.boardView && (
            <>
              <RangeDatePicker
                startDate={this.state.filters.startDate}
                endDate={this.state.filters.endDate}
                onChange={this.setDateFilters}
              />
              {this.hasAdditionalFilters() && (
                <AdditionalFilters
                  additionalFilters={this.state.additionalFilters}
                  filters={this.state.filters}
                  changeAdditionalFilters={this.changeAdditionalFilters}
                  isFilteredByAdditionalFilters={this.isFilteredByAdditionalFilters}
                />
              )}
            </>
          )}
          <SwitchView isBoardView={this.state.boardView} changeView={this.changeView} />
        </section>
        {this.state.showAddDealModal && (
          <DealsModal
            showAddDealModal={this.state.showAddDealModal}
            toggleAddDealModal={this.toggleAddDealModal}
            createDeal={this.createDeal}
            users={this.props.users}
            navigate={this.props.router.navigate}
          />
        )}
        <Outlet
          context={{
            filteredByUser: this.state.filteredByUser,
            onLaneScroll: this.onLaneScroll,
            changeStatus: this.changeStatus,
            boardData: this.props.boardData,
            toggleSelectAllDeals: this.toggleSelectAllDeals,
            addBoardColumnRef: this.addBoardColumnRef,
            boardHeaders: this.props.boardHeaders,
            updateDealsStatusFollowupDate: this.updateDealsStatusFollowupDate,
            navigateTo: this.navigateTo,
            dealsStatuses: this.props.dealsStatuses,
            toggleSelectDeal: this.toggleSelectDeal,
            expandCard: this.expandCard,
            updateDraggedDealFollowupDate: this.updateDraggedDealFollowupDate
          }}
        />
        <FollowupDateModal
          entity={this.state.draggedDeal}
          onSave={this.updateDealStatusFollowupDate}
          showFollowupDateModal={this.state.showDealFollowup}
          toggleFollowupDateModal={this.toggleFollowupDateModal}
          title="Opportunity"
          cancelCb={this.cancelUpdateFollowUp}
        />
        {this.state.showContractorAwardedModal && (
          <ContractorAwardedModal
            entity={this.state.draggedDeal}
            companies={this.props.companies}
            showContractorAwardedModal={this.state.showContractorAwardedModal}
            toggleContractorAwardedModal={this.toggleContractorAwardedModal}
            cancelCb={this.cancelContractorAwarded}
            onSave={this.updateDealStatusContractorAwarded}
            isWonByUs={this.state.isWonByUs}
          />
        )}
        {this.state.showLostOpportunityModal && (
          <LostOpportunityModal
            entity={this.state.draggedDeal}
            showLostOpportunityModal={this.state.showLostOpportunityModal}
            toggleLostOpportunityModal={this.toggleLostOpportunityModal}
            cancelCb={this.cancelLostOpportunity}
            onSave={this.updateDealStatusContractorAwarded}
            status={this.state.draggedDealNewStatus}
          />
        )}
      </>
    )
  }
}

export default DealsContainer
